export default countryIso => `
  {
    currentOrder {
      number
      checkoutVersion
      state
      email
      completedAt
      containsSocks
      isNewsletterSubscribed
      isRegistrationValid
      isShippingValid
      isPaymentValid
      isTaxIncluded
      adyenTotalAmount
      items {
        sku
        variantId
        color
        name
        groupName
        imageUrl
        price
        productPath
        productType
        quantity
        size
        stock
      }
      promotionAdjustment {
        code
        amount
      }
      taxAdjustments {
        label
        amount
        type
      }
      accountShippingAddressId
      shippingAddress {
        id
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          id
          name
          abbr
        }
      }
      accountBillingAddressId
      billingAddress {
        id
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          id
          name
          abbr
        }
      }
      shippingRates {
        id
        name
        price
        displayPrice
        selected
        estimatedDelivery
        notice
      }
      isPreorder
      preorderDeliveryDate
    }
    currentUser {
      id
      email
      first_name
      last_name
      newsletter_subscribed
      addresses {
        id
        gender
        firstname
        lastname
        document_number
        address1
        address2
        neighborhood
        city
        ibge_city_code
        zipcode
        phone
        state_id
        country_id
        is_default
        countryData {
          name
          iso
        }
        stateData {
          id
          name
          abbr
        }
      }
      savedPayments {
        reference
        variant
        createdAt
        cardNumber
        cardHolderName
        cardExpiryMonth
        cardExpiryYear
      }
    }
    currentStore {
      shipping {
        cost
        threshold
      }
      currency {
        code
        symbol
        thousandsSeparator
        decimalMark
        symbolFirst
      }
      customerServiceEmail
      customerServicePhone
    }
    paths {
      updateCheckoutRegistrationUrl
      explorePath
      login
      logout
      signUp
      profile
      orders
      cartUrl
      termsAndConditionsUrl
      contactCustomerSupportUrl
      privacyPolicyUrl
    },
    territories {
      states(countryIso: "${countryIso}") {
        id
        name
      }
      countries {
        id
        iso
        name
        hasStates
        requireZipcode
        requireStates
        nameTranslated
        isShippingCountry
      }
    }
  }
`
